<ncp-table #demographics [(options)]="options"></ncp-table>

<ncp-modal #mod [options]="modalOptions()">
  @if(modalOptions().title === 'edit_email') {
    <form
      id="email_form"
      name="email_form"
      [formGroup]="emailForm"
      #eFrm= "ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit(emailForm, 'email')"
    >
      <ncp-input [(options)]="oldEmailInputOptions" />
      <ncp-input #newEmail [(options)]="newEmailInputOptions" />
      @if(emailOTPCode.enabled || emailOTPCode.hasValidator(Validators.required)) {
        <ncp-input #otpEmail [(options)]="emailOTPInputOptions" />
      }
    </form>
  } @else if(modalOptions().title === 'edit_phone') {
    <form
      id="phone_form"
      name="phone_form"
      [formGroup]="phoneForm"
      #pFrm= "ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit(phoneForm, 'phone')"
    >
      <ncp-input [(options)]="oldPhoneInputOptions" />
      <ncp-input #newPhone [(options)]="newPhoneInputOptions" />
      @if(phoneOTPCode.enabled || phoneOTPCode.hasValidator(Validators.required)) {
        <ncp-input #otpPhone [(options)]="phoneOTPInputOptions" />
      }
    </form>
  } @else if(modalOptions().title === 'edit_address') {
    <form
      id="address_form"
      name="address_form"
      [formGroup]="addressForm"
      #aFrm= "ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit(addressForm, 'address')"
    >
      <div class="row">
        <div class="col-md-8 col-12">
          <ncp-input [(options)]="addressInputOptions" />
        </div>
        <div class="col-md-4 col-12 mt-md-0 mt-3">
          <ncp-input [(options)]="addressNumberInputOptions" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-12">
          <ncp-input [(options)]="addressPostCodeInputOptions" />
        </div>
        <div class="col-md-4 col-12 mt-md-0 mt-3">
          <ncp-input [(options)]="addressCityInputOptions" />
        </div>
        <div class="col-md-4 col-12 mt-md-0 mt-3">
          <ncp-input [(options)]="addressCountryInputOptions" />
        </div>
      </div>
    </form>
  }
</ncp-modal>
